
<!--
Sökruta
-->
@if (showFilter === true) {
  <div class="input-group input-group-sm mb-3">
    <span class="input-group-text"><i class="fas fa-search"></i></span>
    <input  type="text" class="form-control"
      [(ngModel)]="filterText" (input)="filterChange()"
      placeholder="{{ 'urval.filter.placeholder' | translate }}" />
      <span class="input-group-text clickable" (click)="filterText='';filterChange();"><i class="fas fa-xs fa-times"></i></span>
    </div>
  }

  @if (hasFilter) {
    <div>
      <p class="font-italic mb-2"> {{ 'urval.filter.searchresult-for' | translate:{filter: filterText} }}</p>
    </div>
  }


  <!--
  Checkbox-träd
  -->
  @if (!showOnlyFilter || (showOnlyFilter && hasFilter)) {
    <ng-template #defaultCheckboxItem let-item="item">
      <div class="checkbox-row clickable">
        <span (click)="item.collapsed = !item.collapsed" class="collapse-caret">
          @if (item.children && !item.collapsed) {
            <span class="caret-down"></span>
          }
          @if (item.children && item.collapsed) {
            <span class="caret-right"></span>
          }
          @if (!item.children) {
            <span>&ensp;</span>
          }
        </span>
        <span class="checkbox-icon" (click)="clickedItem(item)">
          @if (item.nonechecked || (!item.someChecked && !item.checked)) {
            <span class="checked-none"></span>
          }
          @if (item.someChecked) {
            <span class="checked-some"></span>
          }
          @if (item.checked) {
            <span class="checked-all"></span>
          }
        </span>
        <span hidden>{{item.value}}</span>
        <span class="checkbox-text" (click)="clickedItem(item)">{{item.text}}</span>
      </div>
      @if (item.children) {
        <div>
          @if (!item.collapsed) {
            <ul class="checkbox-children-list">
              @for (childItem of item.children; track childItem.text) {
                <li>
                  <ng-container [ngTemplateOutlet]="defaultCheckboxItem" [ngTemplateOutletContext]="{item:childItem}"></ng-container>
                </li>
              }
            </ul>
          }
        </div>
      }
    </ng-template>
    <ul class="checkbox-treeview">
      @for (item of treeviewItems; track item.text) {
        <li>
          <ng-container [ngTemplateOutlet]="defaultCheckboxItem" [ngTemplateOutletContext]="{item:item}"></ng-container>
        </li>
      }
    </ul>
  }
